import './styles.scss';

import React from 'react';
import { SelectDropdown } from 'media-base-ui/views/components';

const SeasonSelect = ({selectedSeason, availableSeasons, changeSeasonValue, header = null, searchable = true}) => {
    return (
        <div className="season-select">
            {header !== null ? <h4>{header}</h4> : null}
            <SelectDropdown
                name="season-select"
                label={selectedSeason.label}
                value={selectedSeason.value}
                options={availableSeasons}
                clearable={false}
                searchable={searchable}
                onChange={changeSeasonValue}/>
        </div>
    )
};

export default SeasonSelect;